module.exports = __webpack_public_path__ + "static/media/email.61fc4d2a.svg";